import React, { useState } from 'react';
import { useParams, Navigate } from "react-router-dom";
import ProductGallery from '../../components/ProductGallery/ProductGallery';
import SizeTableCollapsible from '../../components/SizeTableCollapsible/SizeTableCollapsible';
import { useLocalization } from '../../utils/hooks/useLocalization'
import products from "../../data/product";
import artists from "../../data/artist";
import styles from './ProductDetailPage.module.css';

const ProductDetailPage = ({ isMobile }) => {
  const { t, currentLanguage } = useLocalization();

  const { prodId } = useParams();
  const [checkSize, setCheckSize] = useState(null);
  const product = products.items.find((p) => p.id === prodId);
  const artist = artists.items.find((a) => a.id === product?.artist_id);
  // Resolved here so the gallery components stay ignorant of the images/ folder.
  const photos = (product?.id_photos || []).map((path) => require(`../../../images/${path}`));
  if (!product) {
      return <Navigate to={`/${currentLanguage}/products`} replace />
  }

  return (
      <section id="product-detail" className={styles.products}>
        <div className={styles.container}>
          <div className={isMobile ? null : styles.productDetailWrapper}>
            <ProductGallery images={photos} name={product.name} />

            <div className={isMobile ? styles.infoWrapperMobile : styles.infoWrapper}>
              <h3 className={styles.productName}>
                {product.name}
              </h3>
              <h6 className={styles.artist}>
                {t('product_detail_designed_with')} {artist && <a href={`/${currentLanguage}/artist/${artist.id}`}>{artist.nickName}</a>}
              </h6>
              {/* <span className={styles.price}>
                {product.price}
              </span> */}
              <div className={styles.availability}>
                <h5 className={styles.availabilityTitle}>{t('product_detail_availability')}</h5>
                <div className={styles.availabilityBoxes}>
                  {product.availability.map((item) => (
                      false && checkSize === item.size ?
                        <div
                          key={item.size}
                          className={item.stock ? styles.inStockOver : styles.outOfStockOver}
                          onMouseOut={() => setCheckSize(null)}
                        >
                          {item.stock ? "In Stock" : "Out of Stock"}
                        </div>
                      :
                        <div
                          key={item.size}
                          className={true || item.stock ? styles.inStock : styles.outOfStock}
                          onMouseOver={() => setCheckSize(item.size)}
                        >
                          {item.size}
                        </div>
                  ))}
                  </div>
              </div>
              <p className={styles.description}>
                {product.description[currentLanguage]}
              </p>
              <div className={styles.purchaseSection}>
                <div className={styles.cta}>
                  <a href={`/${currentLanguage}/discover`}>
                    <button className={styles.ctaBtn}>
                      {t('product_detail_discover')}
                    </button>
                  </a>
                </div>
              </div>
              <div className={styles.sizeTableContainer}>
                <SizeTableCollapsible data={product.sizeTable} isMobile={isMobile} />
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default ProductDetailPage;